import { render, staticRenderFns } from "./wy-smart-tag-dashboard-table-detail-associated-phrase-hit.vue?vue&type=template&id=a3398ca2&"
import script from "./wy-smart-tag-dashboard-table-detail-associated-phrase-hit.vue?vue&type=script&lang=js&"
export * from "./wy-smart-tag-dashboard-table-detail-associated-phrase-hit.vue?vue&type=script&lang=js&"
import style0 from "./wy-smart-tag-dashboard-table-detail-associated-phrase-hit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports